import { ContactData } from '../types';

const contactData: ContactData = {
  title: "Lass uns in Kontakt treten",
  intro: "Du hast Fragen oder möchtest mit mir zusammenarbeiten? Schreib mir eine Nachricht, und ich melde mich so schnell wie möglich zurück.",
  formLabels: {
    name: "Dein Name",
    email: "Deine E-Mail",
    subject: "Betreff",
    message: "Deine Nachricht",
    submit: "Nachricht senden"
  },
  formPlaceholders: {
    name: "Max Mustermann",
    email: "max@muster.de",
    subject: "Projektanfrage",
    message: "Erzähle mir von Deinem Projekt oder Deiner Anfrage..."
  },
  contactInfo: {
    title: "Kontaktinformationen",
    email: {
      label: "E-Mail",
      value: "kontakt@robinwichmann.com"
    },
    location: {
      label: "Standort",
      value: "Bliedersdorf (bei Hamburg)"
    },
    availability: {
      label: "Verfügbarkeit",
      value: "Montag – Freitag, 9:00 – 17:00 Uhr"
    },
    social: {
      title: "Finde mich auch auf"
    },
    quickResponse: {
      title: "Schnelle Antwort gewünscht?",
      text: "Nutze das Formular und ich melde mich schnellstmöglich bei Dir zurück."
    },
    thankYou: {
      title: "Danke für Dein Interesse",
      text: "Ich freue mich auf spannende neue Projekte und Herausforderungen!"
    }
  },
  socialLinks: [
    {
      name: "LinkedIn",
      url: "https://www.linkedin.com/in/robin-wichmann-a0078478/",
      icon: "linkedin"
    },
    {
      name: "GitHub",
      url: "https://github.com/Marvbuster",
      icon: "github"
    }
  ],
  successMessage: {
    title: "Vielen Dank für Deine Nachricht!",
    message: "Ich werde mich so schnell wie möglich bei Dir melden.",
    newFormButton: "Neues Formular"
  },
  errorMessage: "Es ist ein Fehler aufgetreten. Bitte versuche es später erneut."
};

export default contactData;